export default __webpack_public_path__ + "media/images/google_logo-85707a335f8d3583332cd37cd22bc38c.png";